import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Register from '@/components/Register'
import Profile from '@/components/Profile'
import UserNew from '@/components/UserNew'
import Calculator from '@/components/Calculator'
import Keszlet from '@/components/Keszlet'
import KeszletNew from '@/components/KeszletNew'
import Ertekesites from '@/components/Ertekesites'
import ErtekesitesNew from '@/components/ErtekesitesNew'
import ErtekesitesPreview from '@/components/ErtekesitesPreview'
import NyomdaiMunkak from '@/components/NyomdaiMunkak'
import NyomdaiMunkakNew from '@/components/NyomdaiMunkakNew'
import NyomdaiMunkakPrint from '@/components/NyomdaiMunkakPrint'
import Munkalap from '@/components/Munkalap'
import MunkalapNew from '@/components/MunkalapNew'
import Cikkek from '@/components/Cikkek'
import CikkekNew from '@/components/CikkekNew'
import CikkCsoport from '@/components/CikkCsoport'
import CikkCsoportNew from '@/components/CikkCsoportNew'
import Anyagtipusok from '@/components/Anyagtipusok'
import AnyagtipusokNew from '@/components/AnyagtipusokNew'
import Status from '@/components/Status'
import StatusNew from '@/components/StatusNew'
import UserNewPassword from '@/components/UserNewPassword'
import gyartok from '@/components/Gyartok'
import gyartoknew from '@/components/GyartokNew'
import raktarak from '@/components/Raktarak'
import raktaraknew from '@/components/RaktarakNew'
import { BootstrapVue } from 'bootstrap-vue'
import { BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

Vue.use(Router)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/userNew',
      name: 'UserNew',
      component: UserNew
    },
    {
      path: '/userNewPassword',
      name: 'UserNewPassword',
      component: UserNewPassword
    },
    {
      path: '/keszlet',
      name: 'Keszlet',
      component: Keszlet
    },
    {
      path: '/keszletnew',
      name: 'KeszletNew',
      component: KeszletNew
    },
    {
      path: '/ertekesites',
      name: 'Ertekesites',
      component: Ertekesites
    },
    {
      path: '/ertekesitesNew',
      name: 'ErtekesitesNew',
      component: ErtekesitesNew
    },
    {
      path: '/ertekesitespreview',
      name: 'ErtekesitesPreview',
      component: ErtekesitesPreview
    },
    {
      path: '/nyomdaimunkak',
      name: 'NyomdaiMunkak',
      component: NyomdaiMunkak
    },
    {
      path: '/nyomdaimunkaknew',
      name: 'NyomdaiMunkakNew',
      component: NyomdaiMunkakNew
    },
    {
      path: '/nyomdaimunkakprint/:id',
      name: 'NyomdaiMunkakPrint',
      component: NyomdaiMunkakPrint
    },
    {
      path: '/munkalap',
      name: 'Munkalap',
      component: Munkalap
    },
    {
      path: '/munkalapnew',
      name: 'MunkalapNew',
      component: MunkalapNew
    },
    {
      path: '/cikkek',
      name: 'Cikkek',
      component: Cikkek
    },
    {
      path: '/cikkekNew',
      name: 'CikkekNew',
      component: CikkekNew
    },
    {
      path: '/cikkcsoport',
      name: 'CikkCsoport',
      component: CikkCsoport
    },
    {
      path: '/cikkcsoportNew',
      name: 'CikkCsoportNew',
      component: CikkCsoportNew
    },
    {
      path: '/status',
      name: 'Status',
      component: Status
    },
    {
      path: '/statusNew',
      name: 'StatusNew',
      component: StatusNew
    },
    {
      path: '/anyagtipusok',
      name: 'Anyagtipusok',
      component: Anyagtipusok
    },
    {
      path: '/anyagtipusokNew',
      name: 'AnyagtipusokNew',
      component: AnyagtipusokNew
    },
    {
      path: '/calculator',
      name: 'Calculator',
      component: Calculator
    },
    {
      path: '/gyartok',
      name: 'Gyartok',
      component: gyartok
    },
    {
      path: '/gyartoknew',
      name: 'GyartokNew',
      component: gyartoknew
    },
    {
      path: '/raktarak',
      name: 'Raktarak',
      component: raktarak
    },
    {
      path: '/raktaraknew',
      name: 'RaktarakNew',
      component: raktaraknew
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js